import defaultSounds from './default';

export const BOARD_SOUND_THEMES = {
  none: null,
  default: defaultSounds,
};

export type BoardSoundThemes = keyof typeof BOARD_SOUND_THEMES;
